import React, { useState, useEffect } from 'react';
import { Card, Button, Badge, PageHeader, Alert } from '../../components/ui';
import api from '../../services/api';
import toast from 'react-hot-toast';

export default function DeletedClients() {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { fetchDeleted(); }, []);

  const fetchDeleted = async () => {
    setLoading(true);
    try { const r = await api.get('/superadmin/deleted'); setClients(r.data.clients || []); }
    catch { toast.error('Failed to load'); } finally { setLoading(false); }
  };

  const recover = async (client) => {
    if (!window.confirm(`Recover ${client.name}'s account?`)) return;
    try { await api.post(`/superadmin/clients/${client.id}/recover`); toast.success('Account recovered!'); fetchDeleted(); }
    catch (e) { toast.error(e.response?.data?.message || 'Recovery window may have expired'); }
  };

  const getHoursLeft = (deletedAt) => {
    const hrs = 48 - Math.floor((Date.now() - new Date(deletedAt)) / (1000 * 60 * 60));
    return Math.max(0, hrs);
  };

  return (
    <div>
      <PageHeader title="Deleted Clients — Recovery" subtitle="Accounts deleted within the last 48 hours can be recovered" />

      <Alert type="warning" style={{ marginBottom: 20 }}>
        Deleted accounts are permanently removed after 48 hours. Recover before the window expires.
      </Alert>

      {loading ? <div style={{ color:'#555', textAlign:'center', padding:40 }}>Loading...</div> : (
        clients.length === 0 ? (
          <Card style={{ textAlign: 'center', padding: 60 }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>🗑️</div>
            <h3 style={{ color: '#ccc', marginBottom: 8 }}>No recoverable accounts</h3>
            <p style={{ color: '#555', fontSize: 14 }}>No clients have been deleted in the last 48 hours.</p>
          </Card>
        ) : (
          <Card style={{ padding: 0, overflow: 'hidden' }}>
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                <thead>
                  <tr style={{ background: 'rgba(231,76,60,0.05)', borderBottom: '1px solid rgba(231,76,60,0.15)' }}>
                    {['Name','Email','Company','Plan','Deleted At','Time Left','Action'].map(h => (
                      <th key={h} style={{ padding: '12px 16px', textAlign: 'left', color: '#888', fontWeight: 700, fontSize: 11, textTransform: 'uppercase' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {clients.map(c => {
                    const hoursLeft = getHoursLeft(c.deletedAt);
                    return (
                      <tr key={c.id} style={{ borderBottom: '1px solid rgba(255,255,255,0.03)' }}>
                        <td style={{ padding: '12px 16px', fontWeight: 700, color: '#fff' }}>{c.name}</td>
                        <td style={{ padding: '12px 16px', color: '#888' }}>{c.email}</td>
                        <td style={{ padding: '12px 16px', color: '#888' }}>{c.company}</td>
                        <td style={{ padding: '12px 16px', color: '#2ECC71', fontWeight: 600, fontSize: 12 }}>{c.planId?.replace(/_/g,' ')}</td>
                        <td style={{ padding: '12px 16px', color: '#666', fontSize: 12 }}>{c.deletedAt ? new Date(c.deletedAt).toLocaleString() : '—'}</td>
                        <td style={{ padding: '12px 16px' }}>
                          <span style={{ color: hoursLeft < 6 ? '#E74C3C' : hoursLeft < 24 ? '#F39C12' : '#2ECC71', fontWeight: 700, fontSize: 13 }}>
                            {hoursLeft}h left
                          </span>
                        </td>
                        <td style={{ padding: '12px 16px' }}>
                          <Button size="sm" onClick={() => recover(c)}>🔄 Recover</Button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </Card>
        )
      )}
    </div>
  );
}
